module.exports = __webpack_public_path__ + "img/Comic_42.450f7221.png";